import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";

import { firebaseAuth } from "../firebase/app";

const initialState = {
  name: "",
  uid: localStorage.getItem("branchUid"),
  token: "",
  buyAgent: false,
  role: "manager",
  roleTitle: "manager",
  originUid: null,
  adminUid: null,
  staffUid: null,
};

export const handleToken = createAsyncThunk("auth/handleToken", async () => {
  try {
    const user = firebaseAuth.currentUser;
    if (user) {
      // Get the Auth token
      return await user.getIdToken();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
});

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    authSet: (state, { payload }) => {
      if (payload === undefined) {
        state.name = "undefined";
        state.uid = localStorage.getItem("branchUid");
        state.originUid = null;
        state.token = "";
        state.buyAgent = false;
        state.role = "manager";
        state.role = "manager";
        state.adminUid = null;
        state.staffUid = null;
      } else {
        const { displayName, uid, token, buyAgent, role, staffUid, roleTitle } = payload;
        state.name = displayName;
        state.uid = localStorage.getItem("branchUid") || uid;
        state.originUid = uid;
        state.token = token;
        state.buyAgent = buyAgent;
        state.role = role;
        state.roleTitle = roleTitle;
        state.staffUid = staffUid;
      }
    },
    adminUidSet: (state, { payload }) => {
      state.adminUid = payload;
    },
    tokenSet: (state, { payload }) => {
      state.token = payload;
    },
    buyAgentSet: (state, { payload }) => {
      state.buyAgent = payload;
    },
    branchUidSet: (state, { payload }) => {
      state.uid = payload;
    },
    roleSet: (state, { payload }) => {
      state.role = payload;
    },
    roleTitleSet: (state, { payload }) => {
      state.roleTitle = payload;
    },
    logout: (state) => {
      state.token = "";
      state.uid = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(handleToken.fulfilled, (state: any, { payload }: any) => {
      state.token = payload;
    });
    builder.addCase(handleToken.rejected, () => {
      console.log("@handleToken error");
    });
    builder.addCase(handleToken.pending, () => {
      console.log();
    });
  },
});

export const getToken = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.token
);

export const getUid = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.uid
);

export const getStaffUid = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.staffUid
);

export const getOriginUid = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.originUid
);

export const getRole = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.role
);

export const getRoleTitle = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.roleTitle
);

export const getAdminUid = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.adminUid
);

export const getIsBuyAgent = createSelector(
  (state: any) => state.auth,
  (auth: any) => auth.buyAgent
);

export default authSlice.reducer;
export const { authSet, logout, branchUidSet, buyAgentSet, adminUidSet, roleTitleSet } =
  authSlice.actions;
